import { usePage } from "@inertiajs/react";
import { useEffect, useState } from "react";

import { DefaultPageType } from "types/DefaultPageType";

// This custom hook let us know whether current path is
// initially opened by user from link or external source
export const useIsCurrentPageInitial = () => {
  const { pathName } = usePage<DefaultPageType>().props;
  const [pathStack, setPathStack] = useState([]);

  useEffect(() => {
    if (pathStack.length === 0) {
      // No other paths saved, this is the first load
      setPathStack([pathName]);
    } else if (pathStack[pathStack.length - 2] === pathName) {
      // Went back, remove last path
      const newPath = [...pathStack];
      newPath.splice(pathStack.length - 1, 1);
      setPathStack(newPath);
    } else {
      // Went forward, add a new path
      setPathStack([...pathStack, pathName]);
    }
  }, [pathName]);

  return pathStack.length === 0 || pathStack.length === 1;
};
